import React from 'react'
import Head from 'next/head'
import styled from 'styled-components'
import { Relative, Absolute, Image } from 'pcln-design-system'
import {
  ContentfulImage,
  IContentfulImageProps
} from '@pcln/contentful-components'

const StyledContent = styled(Relative)`
  max-width: 1280px;
  margin: 0 auto;
`
const StyledAbsolute = styled(Absolute)`
  overflow: hidden;
`

type HeroProps = {
  img: string
  children: JSX.Element
  description?: string
  className?: string
  contentfulImage?: IContentfulImageProps
}

export default function Hero({
  img,
  children,
  description = 'Hero background Image',
  className,
  contentfulImage
}: HeroProps) {
  return (
    <div className={className}>
      {!contentfulImage && (
        <Head>
          <link rel="preload" as="image" href={img} />
        </Head>
      )}
      <Relative>
        <StyledContent zIndex={10} pt={4} pb="40px" px={4}>
          {children}
        </StyledContent>
        <StyledAbsolute bottom={0} left={0} right={0} top={0}>
          {contentfulImage ? (
            <ContentfulImage
              asset={contentfulImage?.asset}
              altText="Hero image"
              width={1680}
              height={750}
              className="hero-image"
              format="jpg"
            />
          ) : (
            <Image
              src={img}
              alt={description}
              width={1}
              className="hero-image"
            />
          )}
        </StyledAbsolute>
      </Relative>
    </div>
  )
}
